import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["elementData"];
import { useSelector, useDispatch } from 'react-redux';

// @ts-expect-error no declarations found for module
import { getIsReadOnlyMode } from 'EmailEditorUI/redux/selectors/ReadOnlySelector';
import MoveableTile from 'LayoutBuilderUI/components/tiles/MoveableTile';
import { getRecentlyUsedModulesIds } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomModuleTile = _ref => {
  let {
      elementData = {}
    } = _ref,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isReadOnlyMode = useSelector(getIsReadOnlyMode);
  const recentlyUsedModulesIds = useSelector(getRecentlyUsedModulesIds);
  const dispatch = useDispatch();
  return /*#__PURE__*/_jsx(MoveableTile, Object.assign({
    disabled: isReadOnlyMode,
    disabledMessage: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "app.readOnly.title"
    }),
    elementData: elementData,
    dispatch: dispatch,
    "data-test-id": "custom-module-tile",
    recentlyUsedModulesList: recentlyUsedModulesIds
  }, otherProps));
};
export default CustomModuleTile;